module.exports = __webpack_public_path__ + "img/choppy_the_log_surfer.76fad64a.png";